import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ItemModel, MenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';
import { Subscription } from 'rxjs';
import { fadeInOut } from 'src/app/animations';
import { ListeFixeCategoriesTacheService } from 'src/app/services/gestion-projet/liste-fixe-categories-tache.service';
import { TachesStoreService } from 'src/app/services/taches/taches.services';
import { FonctionLogicielle } from '../../../constantes/fonctions-logicielle-constantes';
import { ValeurListeFixeModel } from '../../../models/listes-fixes/valeur-liste-fixe.model';
import { EtatTache, LienTache, Tache, TypeLien } from '../../../models/taches/gestion-taches.model';
import { NavigationService } from '../../../navigation/services/navigation.service';
import { GestionProjetService } from '../../../services/gestion-projet/gestion-projet.service';

@Component({
  selector: 'app-tache',
  templateUrl: './tache.component.html',
  styleUrls: ['./tache.component.scss'],
  animations: [fadeInOut]
})
export class TacheComponent implements OnInit, OnDestroy {
  MENU_SUPPRIMER = 'menuSupprimer';
  MENU_MODIFIER = 'menuModifier';
  TypeLien = TypeLien;

  listeFixeCategoriesTache: ValeurListeFixeModel[];
  private subs: Subscription[] = [];

  toggleSlideTask = false;
  @Input() tache: Tache
  @Input() canEdit: boolean;
  @Input() canDelete: boolean;
  @Output() editRequested: EventEmitter<Tache> = new EventEmitter<Tache>();
  @Output() itemSupprime: EventEmitter<number> = new EventEmitter<number>();
  @Output() requestClosePanel = new EventEmitter();
  @Output() tacheMarkedAsFinished = new EventEmitter<Tache>()
  @ViewChild('inputFocus') inputFocus: ElementRef;


  public menu: ItemModel[];
  private menuActions = {
    [this.MENU_MODIFIER]: () => { this.requestModification() },
    [this.MENU_SUPPRIMER]: () => { this.suppression() }
  };
  FonctionLogicielle = FonctionLogicielle;
  tooltipDisplayed: LienTache = null;
  Tache = Tache;

  get readonly(): boolean {
    return !this.canEdit && !this.canDelete;
  }

  getHeureDebut(): string {
    return this.tache.heureDebut.replace(':', 'h');
  }

  get liensPersonnes(): LienTache[] {
    return this.tache.liens?.filter(l => l.typeLien == TypeLien.personne);
  }

  get liensFormateurs(): LienTache[] {
    return this.tache.liens?.filter(l => l.typeLien == TypeLien.formateur);
  }

  get liensEntreprises(): LienTache[] {
    return this.tache.liens?.filter(l => l.typeLien == TypeLien.entreprise);
  }

  get liensSessions(): LienTache[] {
    return this.tache.liens?.filter(l => l.typeLien == TypeLien.session);
  }

  get liensPersonnels(): LienTache[] {
    return this.tache.liens?.filter(l => l.typeLien == TypeLien.personnel);
  }

  constructor(
    private gestionProjetService: GestionProjetService,
    private navigationService: NavigationService,
    private listeFixeCategoriesTacheService: ListeFixeCategoriesTacheService,
    private tachesStore: TachesStoreService,
    ) {
  }

  toggleTacheCompletion() {
    const nouvelEtat = this.tache.etat === EtatTache.Termine
      ? EtatTache.AFaire
      : EtatTache.Termine;

    const updated: Tache = { ...this.tache, etat: nouvelEtat };

    this.subs.push(
      this.gestionProjetService.upsertTache(updated).subscribe(() => {
        this.tachesStore.updateTache(updated);
        this.tacheMarkedAsFinished.emit(updated);
      })
    );
  }


  ngOnInit() {
    this.menu = [];
    if (this.canEdit) {
      this.menu.push({
        text: 'Modifier',
        id: this.MENU_MODIFIER,
      });
    }
    if (this.canDelete) {
      this.menu.push({
        text: 'Supprimer',
        id: this.MENU_SUPPRIMER,
      });
    }
    this.subs.push(
      this.listeFixeCategoriesTacheService.getValeurs().subscribe(liste => (this.chargerListeFixe(liste)))
    );
  }

  ngOnDestroy() {
    this.subs.forEach(it => it.unsubscribe());
    this.subs = [];
  }

  doMenuAction(args: MenuEventArgs) {
    this.menuActions[args.item.id]()
  }

  getElementId() {
    return `tache-${this.tache.id}`;
  }

  getLibelleCategorie() {
    return this.listeFixeCategoriesTache?.find(e => e.id == this.tache.idCategorie)?.libelle
  }

  chargerListeFixe(liste: Array<ValeurListeFixeModel>) {
    this.listeFixeCategoriesTache = [{ id: null, libelle: '' }];
    let value: ValeurListeFixeModel;
    for (value of liste) {
      this.listeFixeCategoriesTache.push(value);
    }
  }

  requestModification() {
    this.editRequested.emit(this.tache);
  }

  suppression() {
    if (this.tache == undefined) {
      return;
    }
    this.gestionProjetService.deleteTache(this.tache.id).subscribe(() => this.itemSupprime.emit(this.tache.id));
  }

  showTooltipFor(cible: LienTache) {
    this.tooltipDisplayed = cible;
  }

  hasHeureDebut() {
    return this.tache.heureDebut != null
  }

  navigate(id: number, typeLien: TypeLien) {
    switch (typeLien) {
      case TypeLien.personne:
        this.navigationService.personnes.editionGeneral.navigate(id);
        break;
      case TypeLien.formateur:
        this.navigationService.formateurs.editionGeneral.navigate(id);
        break;
      case TypeLien.entreprise:
        this.navigationService.entreprises.edition.navigate(id);
        break;
      case TypeLien.session:
        this.navigationService.sessions.edition_root.navigate(id);
        break;
      case TypeLien.personnel:
        this.navigationService.personnels.edition.navigate(id);
        break;
    }
  }

}
